import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'; // Assuming you are using react-router for navigation

const NotFoundPage: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
            <p className="text-xl text-gray-600 mb-8">
                {t('not_found_page.page_not_exists')}
            </p>
            <Link
                to="/"
                className="text-primary text-lg font-medium hover:underline"
            >
                {t('not_found_page.go_back_home')}
            </Link>
            {/* <img
                src="/path/to/your/image.png"
                alt="Not Found"
                className="mt-8 w-64 h-64 object-contain"
            /> */}
        </div>
    );
};

export default NotFoundPage;
